import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { useMediaQuery } from "@/lib/hooks/use-media-query";
import type { Product } from "@/lib/schemas/paycode/product";
import { OrderTable } from "./table";

type OrderSummaryProps = {
  products: Product[];
  total: number;
  receipt?: boolean;
  limit?: number;
  expanded: boolean;
  onExpandedChange?: (expanded: boolean) => void;
};

export const OrderSummary = ({
  products,
  total,
  receipt,
  limit,
  expanded,
  onExpandedChange,
}: OrderSummaryProps) => {
  const isDesktop = useMediaQuery("(min-width: 64rem)");

  const inlineLimit = isDesktop && expanded ? undefined : limit;

  const onShowAll = () => {
    onExpandedChange?.(true);
  };

  return (
    <>
      <OrderTable
        products={products}
        total={total}
        receipt={receipt}
        limit={inlineLimit}
        onShowAll={onShowAll}
        staggerFrom={
          isDesktop && expanded && limit != null ? limit - 1 : undefined
        }
      />
      <Drawer open={!isDesktop && expanded} onOpenChange={onExpandedChange}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>Resumen de la orden</DrawerTitle>
          </DrawerHeader>
          <div className="overflow-y-auto px-4 pb-4">
            <OrderTable products={products} total={total} receipt={receipt} />
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};
